import angular from 'angular'

angular.module('nominas.shared')
  .directive('idNominaExisteValidator', idNominaExisteValidator);

function idNominaExisteValidator($api, $q) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      ngModel.$asyncValidators.idNominaExiste = function (value) {
        return angular.isString(value) && value !== ''
          ? $api.get('/kendu/app/nominas/idNominaExiste', {idNomina: value})
            .then(function (existe) {
              return existe ? $q.when() : $q.reject();
            })
          : $q.when();
      };
    },
  };
}



// WEBPACK FOOTER //
// ./src/nominas/shared/directives/idNominaExisteValidator/idNominaExisteValidator.js